import { createActionConst } from '../../../utils/action.utils';

const CHECKLIST_NAMESPACE = 'CHECKLIST';

export const STORE_CHECKLIST = createActionConst(CHECKLIST_NAMESPACE, 'STORE_CHECKLIST');
export const CLEAR_CHECKLIST = createActionConst(CHECKLIST_NAMESPACE, 'CLEAR_CHECKLIST');
